module.exports = __webpack_public_path__ + "img/magnifying-glass-dollar.f867ca4a.svg";